/**
 * Transient network-error helper.
 *
 * On a hard page load, auxiliary dashboard fetches can fire while the
 * HttpOnly session-cookie handshake is still settling, surfacing as a
 * `TypeError: Failed to fetch`. These self-recover on the next render,
 * so logging them as errors only adds first-paint console noise.
 *
 * Use `logIfReal(label, err)` in non-critical catch blocks: real errors
 * are still logged; transient network blips are swallowed quietly.
 */

export const isTransientNetworkError = (err) => {
  if (!err) return false;
  const msg = (err.message || String(err)).toLowerCase();
  return (
    err instanceof TypeError &&
    (msg.includes('failed to fetch') ||
      msg.includes('networkerror') ||
      msg.includes('load failed'))
  );
};

export const logIfReal = (label, err) => {
  if (isTransientNetworkError(err)) return;
  console.error(`${label}:`, err);
};
